'use es6';

import React from 'react';
import styled from 'styled-components';

var SVGTextBase = function SVGTextBase(props) {
  return React.createElement("text", Object.assign({
    x: "50",
    width: "100%"
  }, props));
};

export default styled(SVGTextBase).withConfig({
  displayName: "SVGTextStyle",
  componentId: "f5dc5e-0"
})(["alignment-baseline:middle;dominant-baseline:middle;text-transform:uppercase;user-select:none;"]);